import * as EXIF from 'exif-js';
import sha256 from "crypto-js/sha256";
export const isMobile = window.innerWidth < 960;
export const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator?.platform);
export const isIOS = /(iPhone|iPod|iPad)/i.test(navigator?.platform);
export const isApple = isMac || isIOS;
export const fromWebBot = window?.location?.href?.includes('fromBot=1');

export const isLocalhost = () => {
    if (isOnPremises()) return false
    const hostname = window.location.hostname;
    const localhostRegex = /^(.*\.)?localhost$/;
    return localhostRegex.test(hostname);
};

export const isOnPremises = () => {
    if (window.isOnPremises) return true
    const hostname = window.location.hostname;
    const port = window.location.port;
    const localhostRegex = /^(.*\.)?localhost$/;

    const isLocalhost = localhostRegex.test(hostname);
    const isCorrectPort = port === '38593';

    return isLocalhost && isCorrectPort;
};

export const RESOURCE = {tokens: 'credits', bonusTokens: 'bonusTokens'}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getTokenNameByResourceId = (resourceId) => {
    const myMap = {
        [RESOURCE.tokens]: 'Credits',
        [RESOURCE.bonusTokens]: 'Bonus Tokens',
    };

    return myMap[resourceId];
}

export const getFullTokenNameByResourceId = (resourceId) => {
    const myMap = {
        [RESOURCE.tokens]: 'Platform Credits',
        [RESOURCE.bonusTokens]: 'Bonus Tokens',
    };

    return myMap[resourceId];
}

export const is_on_premises = isOnPremises();
export const is_localhost = isLocalhost();

// export const is_localhost = window.location.href.startsWith('http://localhost');

export function matchesAnyRegex(string, regexArray) {
    for (let i = 0; i < regexArray.length; i++) {
        if (
            typeof regexArray[i] === 'string' && regexArray[i].toLowerCase() === string.toLowerCase()
            || regexArray[i] instanceof RegExp && regexArray[i].test(string)
        ) {
            return true;
        }
    }
    return false;
}

export function sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

export const getCurrentBaseUrl = () => {
    const {kbIdAsSubdomain, appsPrefix, mainDomain, protocol} = parseKBSubdomain() || {};

    return `${protocol}//${mainDomain}/`;
};

function hexToRgb(hex) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export function convertHexToRgba(hex, opacity) {
    let rgb = hexToRgb(hex);
    return `rgba(${rgb.r},${rgb.g},${rgb.b},${opacity})`;
}

export function generateImageDetectionsId(detections) {
    return sha256(JSON.stringify(detections)).toString();
}
export function sortAndConcatenateMessages(messages) {
    messages.sort((a, b) => a.id - b.id);

    let concatenatedText = '';
    let previousId = 1;
    for (const message of messages) {
        if (typeof message.content === "string" && message.id === previousId + 1) {
            concatenatedText += message.content;
            previousId = message.id;
        }
    }

    return concatenatedText;
}

export function isPredominantlyCyrillic(text, threshold = 0.15) {
    const cyrillicPattern = /[\u0400-\u04FF]/g;
    const cyrillicMatches = text.match(cyrillicPattern) || [];
    const cyrillicCount = cyrillicMatches.length;
    const totalCount = text.length;

    return (cyrillicCount / totalCount) >= threshold;
}

export function extractHTMLContent(content) {
    if (!content) return null;
    const languageDetected = /```(?<language>\w+)/g.exec(content)?.groups?.language;
    const htmlMatch = content.match(/<html[^>]*>[\s\S]*<\/html>/);
    if (htmlMatch && (!languageDetected || languageDetected === 'html')) {
        return htmlMatch[0];
    }
    return null;
}

export function isContentHTML(content) {
    if (!content) return content
    const languageDetected = /```(?<language>\w+)/g.exec(content)?.groups?.language;
    return content?.match?.(/<html[^>]*>[\s\S]*<\/html>/) &&
        (!languageDetected || languageDetected === 'html');
}

export function deepClone(data) {
    return JSON.parse(JSON.stringify(data));
}
export async function rotateImage90Degrees(imageFile, direction) {
    // Create an image object
    const imageUrl = URL.createObjectURL(imageFile);
    const image = new Image();
    image.src = imageUrl;
    await new Promise((resolve) => image.onload = resolve);

    // Create a canvas and a context
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    // Set the canvas dimensions to be the same as the image
    // But swap the width and height because we're rotating 90 degrees
    canvas.width = image.height;
    canvas.height = image.width;

    // Move the origin to the center of the canvas
    context.translate(canvas.width / 2, canvas.height / 2);

    // Rotate the canvas by 90 degrees
    // Counterclockwise for 'left' and clockwise for 'right'
    const rotationAngle = (direction.toLowerCase() === 'left') ? -Math.PI / 2 : Math.PI / 2;
    context.rotate(rotationAngle);

    // Draw the image centered on the origin (which is now the center of the canvas)
    context.drawImage(image, -image.width / 2, -image.height / 2);

    // Convert the canvas back to a Blob and then a File
    const imageFileRotated = await new Promise((resolve) => {
        canvas.toBlob((blob) => {
            const file = new File([blob], imageFile.name, { type: imageFile.type });
            resolve(file);
        }, imageFile.type);
    });

    return imageFileRotated;
}

export async function correctOrientation(image, theta) {
    const orientation = await new Promise((res) => EXIF.getData(image, function() {
        res(EXIF.getTag(this, "Orientation"));
    }));

    switch (orientation) {
        case 3:
            theta += Math.PI;
            break;
        case 6:
            theta += Math.PI / 2;
            break;
        case 8:
            theta -= Math.PI / 2;
            break;
    }

    return theta;
}

export async function rotateImageFile(imageFile) {
    const imageUrl = URL.createObjectURL(imageFile);
    const image = new Image();

    image.src = imageUrl;
    await new Promise((res) => image.onload = res);

    let theta = 0;
    if (imageFile.leveler) {
        const [A, B] = imageFile.leveler;
        theta = Math.atan2(B.y - A.y, B.x - A.x);
    }

    theta = await correctOrientation(image, theta);

    // console.log('theta', theta)

    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');

    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate(-theta);
    context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);

    const imageFileRotated = await new Promise((resolve) => {
        canvas.toBlob((blob) => {
            const file = new File([blob], imageFile.name, { type: imageFile.type });
            resolve(file);
        }, imageFile.type);
    });

    return imageFileRotated;
}

export function parseJSON(str) {
    if (!str || typeof str !== 'string' || !str.startsWith('{') && !str.startsWith('[')) return;
    try {
        return JSON.parse(str);
    } catch (e) {
        // console.log(e)
        return;
    }
}

export function parseJSONWithText(content) {
    const regex = /(.*?)`?`?`?\s*([\{\[].*?[\}\]])\s*`?`?`?(.*)/s;
    let match = content.match(regex);
    if (match?.[2]) {
        return parseJSON(match[2])
    }
}

function showDebugLog() {
    const debugElement = document.getElementById('debug');
    if (debugElement) {
        debugElement.style.display = 'block';
    }
}

export async function logToScreen(message, message2) {
    showDebugLog();
    const debugElement = document.getElementById('debug');
    if (debugElement) {


        // Print text messages
        const pre = document.createElement('pre');
        pre.innerText = String(message);
        debugElement.appendChild(pre);

        if (message2) {
            const pre2 = document.createElement('pre');
            pre2.innerText = String(message2);
            debugElement.appendChild(pre2);
        }

    } else {
        console.error('Failed to find debug element');
    }
}

export function formatBytes(bytes, decimals = 1) {
    if (bytes === 0) return '0 Byte';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function formatTimestamp(isoTimestamp) {
    // Convert the ISO 8601 timestamp to a JavaScript Date object
    const date = new Date(isoTimestamp);

    // Extract the date parts
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');


    // Construct the formatted string
    return `${year}-${month}-${day}  ${hours}:${minutes}`;
}

export function decideFormat(isoTimestamp) {
    const now = new Date();
    const past = new Date(isoTimestamp);
    const diffInMs = now - past;

    // Calculate the difference in hours
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

    if (diffInHours < 12) {
        return timeAgo(isoTimestamp, true);  // Use the original timeAgo function
    } else {
        return formatTimestamp(isoTimestamp);  // Use the original formatTimestamp function
    }
}


export function timeAgo(isoTimestamp, withSeconds = false) {
    const now = new Date();
    const past = new Date(isoTimestamp);
    const diffInMs = now - past;

    const seconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);  // approx
    const years = Math.floor(days / 365);

    if (years > 0) return years === 1 ? '1 year ago' : `${years} years ago`;
    if (months > 0) return months === 1 ? '1 month ago' : `${months} months ago`;
    if (weeks > 0) return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
    if (days > 0) return days === 1 ? '1 day ago' : `${days} days ago`;
    if (hours > 0) return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
    if (minutes > 0) return minutes === 1 ? '1 minute ago' : `${minutes} minutes ago`;
    if (withSeconds && seconds > 0) return seconds === 1 ? '1 second ago' : `${seconds} seconds ago`;

    return 'just now';
}

export const getQueryParams = {
    injectedModel: 'model',
}

// Function to get the value of a query parameter
export function getQueryParamValue(paramName) {
    // Use URLSearchParams to parse the query string
    const queryParams = new URLSearchParams(window.location.search);

    // Get the value of the query parameter
    return queryParams.get(paramName);
}

export function isAutoinstall() {
    return getQueryParamValue('autoinstall') || getQueryParamValue('c')
}

const domainsWhitelist = ['openkbs.com', 'openkbs.net'];

export function validateFromAppDomain(fromAppUrl) {
    try {
        // Create a URL object from the fromAppUrl string
        const url = new URL(fromAppUrl);

        // Extract the hostname from the URL
        const hostname = url.hostname;

        const names = hostname.split('.');
        if (names[names.length-1] === 'localhost'
            || domainsWhitelist.includes(names[names.length-2] + '.' + names[names.length-1])) {
            return true;
        }
    } catch (error) {
        // If fromAppUrl is not a valid URL, it will throw an error
        console.error('Invalid URL:', fromAppUrl);
        return false;
    }
}

export function appendToUrl(urlString, key, value) {
    try {
        const url = new URL(urlString);
        const queryParams = new URLSearchParams(url.search);
        queryParams.set(key, value);
        url.search = queryParams.toString();
        return url.toString();
    } catch (error) {
        console.error('Invalid URL:', urlString);
        return urlString;
    }
}

export function removeFromUrl(urlString, key) {
    try {
        const url = new URL(urlString);
        const queryParams = new URLSearchParams(url.search);
        queryParams.delete(key);
        url.search = queryParams.toString();
        return url.toString();
    } catch (error) {
        console.error('Invalid URL:', urlString);
        return urlString;
    }
}

export function redirectToBase(logoutPressed) {
    const link = document.createElement('a');
    link.href = window.location.href;
    const hostRegex = /^(.+)\.(apps)\.(.+)$/;
    if (hostRegex.test(link.host)) {
        const [, appsPrefix, kbId, mainDomain] = link.host.match(hostRegex);

        if (link.protocol && mainDomain && link.pathname) {
            if (logoutPressed) {
                window.location.href = `${link.protocol}//${mainDomain}/dashboard?logoutFrom=${encodeURIComponent(document.title)}`
            } else {
                let url = `${link.protocol}//${mainDomain}/dashboard?fromApp=` + encodeURIComponent(window.location.href);

                // if (getQueryParamValue('sharedWithMe')) {
                //     url += '&fromShared=1'
                // }

                window.location.href = url
            }
        }

    }
}

export const parseKBSubdomain = (host = window.location.host) => {
    const hostRegex = /^(.+)\.(apps)\.(.+)$/;
    if (hostRegex.test(host)) {
        const [protocol, kbIdAsSubdomain, appsPrefix, mainDomain] = host.match(hostRegex);
        return { kbIdAsSubdomain, appsPrefix, mainDomain, protocol: window.location.protocol };
    }
    return null;
};

export const kbIdToSubdomainUrl = (kbId) => {
    const {protocol, host} = window.location
    return `${protocol}//${kbId}.apps.${host}`;
};

export function convertImageToDataURL(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function() {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.height = img.naturalHeight;
            canvas.width = img.naturalWidth;
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL('image/png');
            resolve(dataURL);
        };
        img.onerror = function() {
            reject(new Error('Could not load image at ' + url));
        };
        img.src = url;
    });
}

export function navigateKBSubdomain(kbId, phoneNotVerified) {
    let href = `${window.location.protocol}//${kbId}.apps.${window.location.host}`;

    if (phoneNotVerified) href += '?pnv=1'
    window.location.href = href
}

export function navigateToBaseURL(prefix = '', blank = false) {
    const parsedSubdomain = parseKBSubdomain();

    if (parsedSubdomain) {
        const baseUrl = parsedSubdomain?.protocol + '//' + parsedSubdomain?.mainDomain;

        if (blank) {
            window.open(`${baseUrl}${prefix}`, '_blank');
        } else {
            window.location.href = `${baseUrl}${prefix}`;
        }
    }
}



